import React from 'react';
import { Box, Button, Typography, IconButton } from '@mui/material';
import { AIAssistantIcon } from './AIAssistantIcon';
import { Colors } from '@styles/index';
import CloseIcon from '@mui/icons-material/Close';

const panelActionBaseSx = {
  textTransform: 'none',
  fontWeight: 500,
  minWidth: 'auto',
  py: 0.5,
  borderRadius: '8px',
  border: '1px solid',
  boxShadow: 'none',
  lineHeight: 1.25,
} as const;

const newChatBtnSx = {
  ...panelActionBaseSx,
  fontSize: '0.75rem',
  px: 1,
  color: '#2563EB',
  borderColor: 'rgba(37, 99, 235, 0.28)',
  backgroundColor: 'rgba(37, 99, 235, 0.06)',
  '&:hover': {
    backgroundColor: 'rgba(37, 99, 235, 0.12)',
    borderColor: 'rgba(37, 99, 235, 0.42)',
  },
} as const;

const suggestBtnSx = {
  ...panelActionBaseSx,
  fontSize: '0.7rem',
  px: 0.75,
  whiteSpace: 'nowrap',
  color: '#7C3AED',
  borderColor: 'rgba(124, 58, 237, 0.28)',
  backgroundColor: 'rgba(124, 58, 237, 0.06)',
  '&:hover': {
    backgroundColor: 'rgba(124, 58, 237, 0.12)',
    borderColor: 'rgba(124, 58, 237, 0.42)',
  },
} as const;

export interface CopilotPanelToolbarProps {
  onNewChat: () => void;
  onSuggestAIUseCase: () => void;
  onHide: () => void;
}

export const CopilotPanelToolbar: React.FC<CopilotPanelToolbarProps> = ({
  onNewChat,
  onSuggestAIUseCase,
  onHide,
}) => (
  <Box
    sx={{
      pr: 5,
      pl: 2,
      py: 1,
      minHeight: 48,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid rgba(168, 85, 247, 0.08)',
      background: Colors.white,
      flexShrink: 0,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <AIAssistantIcon size={18} />
      <Typography
        sx={{
          fontSize: '0.875rem',
          fontWeight: 600,
          color: '#374151',
          letterSpacing: '-0.01em',
        }}
      >
        Search
      </Typography>
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
      <Button onClick={onNewChat} size="small" sx={newChatBtnSx}>
        + New
      </Button>
      <Button onClick={onSuggestAIUseCase} size="small" sx={suggestBtnSx}>
        Suggest AI Use Case
      </Button>
      {/* <Button
        onClick={onHide}
        size="small"
        endIcon={<ArrowForwardIcon sx={{ fontSize: '0.875rem !important' }} />}
        sx={hideBtnSx}
      >
        Hide
         
      </Button> */}

      <IconButton
          onClick={onHide}
          aria-label="Close Search"
          size="small"
          sx={{
            position: 'absolute',
            right: 4,
            top: 9,
            color: '#64748B',
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
    </Box>
  </Box>
);
